const setError = (args, state) => {
  const [name, data] = args
  const field = state.fields[name]

  if (field) {
    if(data != undefined) {
      field.data = {...field.data, ...{error: data.join(', ')}}  
      field.touched = true
    }else{
      field.data = {...field.data, ...{error: undefined}}
      field.touched = true
    } 
  }
}

export default setError